module.exports = "<div class=\"ui-card ui-card-hover padding-md\"\r\n\tng-click=\"$ctrl.seleccionar()\">\r\n\t<div class=\"ui-item margin-md\">\r\n\t\t<div flex>\r\n\t\t\t<span class=\"ui-title-3\">{{::$ctrl.data.Empleado}}</span><br>\r\n\t\t\t<small class=\"tag\">{{::$ctrl.data.ID_Empleado}}@{{::$ctrl.data.Empresa}}</small>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/finanzas/_/empleadoprestamos/components/lista/item/template.html
// module id = 2960
// module chunks = 0